import { Checkbox, FormControlLabel, FormGroup, FormLabel } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { ITalentSearchFilterOption } from '../types';

interface AvailabilityFilterProps {
  name: string;
  options: ITalentSearchFilterOption[];
}

const AvailabilityFilter = ({ name, options }: AvailabilityFilterProps) => {
  const { control } = useFormContext();

  return (
    <FormGroup>
      <FormLabel>Disponibilité</FormLabel>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <>
            {options.map((opt) => (
              <FormControlLabel
                key={opt.value}
                control={
                  <Checkbox
                    checked={(field.value || []).includes(opt.value)}
                    onChange={(e) => {
                      const current = field.value || [];
                      field.onChange(
                        e.target.checked
                          ? [...current, opt.value]
                          : current.filter((v: string) => v !== opt.value),
                      );
                    }}
                  />
                }
                label={`${opt.label} (${opt.count})`}
              />
            ))}
          </>
        )}
      />
    </FormGroup>
  );
};

export default AvailabilityFilter;
